import {DDR} from './ddr.class';

export class DDRMen913Strategy extends DDR {
  constructor() {
    super([600, 5, 11, 60, 45, 0.9, 0.9, 12, 1, 300, 1.8, 4, 20, 375, 1300, 25, 700, 2, 120, 8, 240, 1.9, 1250, 40, 8]);
  }
}
